import Vue from 'vue';
import { format } from 'date-fns';

export default Vue.filter('formatDate', (value, dateFormat) => {
  if (value) {
    return format(new Date(value), dateFormat);
  }
  return '';
});
